import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell, { authInputClass } from "./AuthShell";
import { useAuth } from "./AuthContext";

/**
 * The "enter the code we texted you" step. Login and sign-up differ only in
 * their title and which verify call they make.
 */
const OtpPage = ({ title, verify }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { phone } = useAuth();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    try {
      await verify(code);
      navigate("/", { replace: true });
    } catch {
      setError("کد تایید اشتباه میباشد");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={title}
      errors={[
        error,
        !phone && "شماره موبایل پیدا نشد. لطفاً دوباره از ابتدا تلاش کنید.",
      ]}
      loading={loading}
      submitLabel="تایید"
      onSubmit={handleSubmit}
    >
      <input
        name="code"
        inputMode="numeric"
        autoComplete="one-time-code"
        placeholder="کد تایید را وارد کنید"
        className={authInputClass}
        value={code}
        onChange={(event) => setCode(event.target.value)}
        autoFocus
        required
      />
    </AuthShell>
  );
};

export default OtpPage;
